import "jquery";
//import "jquery-validation";
//import "footable-npm";
import svg4everybody from 'svg4everybody';
import "@fancyapps/fancybox"; //we load by the old way as fancybox cant handle cases where jQuery is loaded multiple times, this way we set it to the given instance.
import "bootstrap"; //Include bootstrap here to ensure that it is included.

export class Global {

    private initToggleButtons(): void {
        $('.btn-toggle, .btn-close, .btn-burger').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let $this = $(this);
            var target = $this.attr('data-target');
            let $target = $(target);

            $this.toggleClass('active');
            $('button').not(this).removeClass('active');

            $('.slideout').not(target).removeClass('active');

            if ($this.hasClass('active')) {
                $target.addClass('active');
                $(document.body).addClass('no-scroll');
            }
            else {
                $target.removeClass('active');
                $(document.body).removeClass('no-scroll');
            }
        });

        $('.btn-close').on('click', function (e) {
            $(document.body).removeClass('no-scroll');
        });
    }

    private initBootstrap(): void {
        //inits tooltips
        $('[data-toggle="tooltip"]').tooltip();

        //Init popovers
        $('[data-toggle="popover"]').popover({});

    }

    private initInputFocus(): void {
        $(".input-matrix").on("click", function () {
            $(this).select();
        });
    }

    init(): void {
        this.initToggleButtons();
        this.initBootstrap();
        this.initInputFocus();
        svg4everybody({
            nosvg: true, // shiv <svg> and <use> elements and use image fallbacks
            polyfill: true
        });
    }
}